import { __awaiter } from "tslib";
import { EpofService } from "@/servicesTs/models/patient/epof";
const moduleEpof = {
    namespaced: true,
    state: {
        epofs: [],
        loading: false,
    },
    getters: {
        getEpofs(state) {
            return state.epofs;
        },
        getLoading(state) {
            return state.loading;
        },
    },
    mutations: {
        setEpofs(state, data) {
            state.epofs = data;
        },
    },
    actions: {
        loadEpofs({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                if (state.epofs.length !== 0) {
                    return;
                }
                state.loading = true;
                // this.padre = [];
                commit("setEpofs", []);
                let response;
                const appVersion = process.env.VUE_APP_CIE10_VERSION;
                const browserVersion = window.localStorage.getItem("epofs_version");
                if (localStorage.getItem("epofs") && localStorage.getItem("epofs") != "null" && appVersion == browserVersion) {
                    response = JSON.parse(localStorage.getItem("epofs"));
                }
                else {
                    response = yield EpofService.getAll();
                    localStorage.setItem("epofs", JSON.stringify(response));
                    localStorage.setItem("epofs_version", appVersion);
                }
                commit("setEpofs", response);
                state.loading = false;
            });
        },
    },
};
export default moduleEpof;
